import React from "react";
import GrComponentFactory from "./gr_component_factory";
import { PositionTypes,
  isValidProgressAmount,
  invalidProgressMessage,
  isValidUpdate } from "../modules/reading_session_helper";
import GrPropTypes from "./shared/gr_prop_types";
import ReadingSessionActions from "../react_actions/reading_session_actions";
import ShelvingsActions from "../react_actions/shelvings_actions";
import ShelvingsStore from "../react_stores/shelvings_store";
import { DEFAULT_SHELVES } from "../modules/default_shelves";
import { merge } from "lodash";
import { connectToLazyStore } from "../react_mixins/gr_reflux";
import Spinner from "./spinner";
import keys from "../modules/keys";
import { focusOnMount } from "../modules/react_ref_helpers";
import { BOOK_ORIGINS } from "../modules/book_origins";

import LongTextPopupForm from "./forms/long_text_popup_form";

export default GrComponentFactory.createClass({
  displayName: "UpdateReadingProgress",
  propTypes: {
    existingReadingSession: React.PropTypes.shape({
      positionType: React.PropTypes.oneOf([PositionTypes.Page,
                                           PositionTypes.Percent]).isRequired,
      currentPosition: React.PropTypes.number.isRequired,
    }).isRequired,
    book: GrPropTypes.book().isRequired,
    MAX_BODY_LENGTH: React.PropTypes.number.isRequired,
  },

  mixins: [connectToLazyStore(ShelvingsStore,
                              "book.bookId",
                              { stateKey: "shelvingInProgress",
                                filterValue: "isShelvingInProgress" })],

  getInitialState() {
    return {
      currentPosition: this.props.existingReadingSession.currentPosition,
      positionType: this.props.existingReadingSession.positionType,
      updateText: "",
    };
  },

  updateProgress(text) {
    const newSessionValues = merge({
      body: text,
    }, this.props.existingReadingSession, this.state);
    if (isValidUpdate(newSessionValues)) {
      if (isValidProgressAmount(newSessionValues)) {
        ReadingSessionActions.updateProgress(newSessionValues);
      } else {
        window.alert(invalidProgressMessage(newSessionValues));
      }
    } else {
      window.alert("Please enter a progress message or amount.");
    }
  },

  syncUpdateText(text) {
    this.setState({ updateText: text });
  },

  showPercentage() {
    return this.state.positionType === PositionTypes.Percent;
  },

  updateProgressChanged(value) {
    this.setState({ currentPosition: value });
  },

  togglePositionType() {
    if (this.state.positionType === PositionTypes.Percent) {
      this.setState({ positionType: PositionTypes.Page });
    } else if (this.state.positionType === PositionTypes.Page) {
      this.setState({ positionType: PositionTypes.Percent });
    }
  },

  finishedBook() {
    ShelvingsActions.shelveBook(this.props.book.bookId,
                                DEFAULT_SHELVES.READ,
                                BOOK_ORIGINS.UPDATE_READING_PROGRESS, // tracking from old HP
                                this.state.updateText); // pass along final progress update text if it exists
  },

  submitOnEnter(ev) {
    if (keys.isEnter(ev.keyCode)) {
      this.form.submit();
    }
  },

  renderInput() {
    const input = <input type="text"
                       aria-label={`Enter current ${this.state.positionType} read in ${this.props.book.title}`}
                       className="gr-textInput
                                  updateReadingProgress__headerInput"
                       size="3"
                       value={this.state.currentPosition}
                       onChange={(ev) => {
                         this.updateProgressChanged(ev.target.value);
                       }}
                       ref={focusOnMount}
                       onKeyDown={this.submitOnEnter}
                       placeholder={this.showPercentage() ?
                         `${this.state.currentPosition}` :
                         `p. ${this.state.currentPosition}`} />;
    if (this.showPercentage()) {
      return <span>
              Currently {input}% done
             </span>;
    } else {
      return <span>
               Currently on {input}
               { this.props.book.numPages ?
                 ` of ${this.props.book.numPages}`
                 : null }
             </span>;
    }
  },

  renderPositionTypeToggle() {
    return <span className="updateReadingProgress__headerToggle">
             <button className="buttonToggle"
                     disabled={this.showPercentage()}
                     onClick={this.togglePositionType}>
               %
             </button>
             <button className="buttonToggle"
                     disabled={!this.showPercentage()}
                     onClick={this.togglePositionType}>
               #
             </button>
           </span>;
  },

  renderHeader() {
    return <div className="updateReadingProgress">
             {this.renderInput()}
             {this.renderPositionTypeToggle()}
             <div className="updateReadingProgress__finishedReading">
               { this.state.shelvingInProgress ?
                 <Spinner/> :
                 <button className="gr-buttonAsLink"
                         onClick={this.finishedBook}>
                   I’m finished!
                 </button>
               }
             </div>
           </div>;
  },

  render() {
    return <LongTextPopupForm
              ref={(form) => { this.form = form; }}
              header={this.renderHeader()}
              characterLimit={this.props.MAX_BODY_LENGTH}
              text={this.state.updateText}
              onSubmit={this.updateProgress}
              onCancel={ReadingSessionActions.closeUpdateProgressForm}
              onTextChange={this.syncUpdateText}
              submitButtonLabel="Update progress"
              textareaProps={
                {
                  "aria-label": "Add update progress text",
                }
              }
           />;
  },
});
